// extracted by mini-css-extract-plugin
module.exports = {"cardsApp":"cards_cardsApp__2dA8p"};